import TabCoaches from "@/views/App/Dashboard/HeadAMDL/TabCoaches.vue";
import TabUnitsDoneByLocation from "@/views/App/Dashboard/HeadAMDL/TabUnitsDoneByLocation.vue";
import TabInfo from "@/views/App/Dashboard/HeadAMDL/TabInfo.vue";
import TabPotentialUnits from "@/views/App/Dashboard/HeadAMDL/TabPotentialUnits.vue";
import UnsignedUnitsLocation from "@/views/App/Dashboard/HeadAMDL/UnsignedUnitsLocation.vue";

const routesDashboardHeadAMDL= [
    {
        path: 'info',
        name: 'dashboardHeadAMDLInfo',
        component: TabInfo
    },
    {
        path: 'coaches',
        name: 'dashboardHeadAMDLCoaches',
        component: TabCoaches
    },
    {
        path: 'potential-units',
        name: 'dashboardHeadAMDLPotentialUnits',
        component: TabPotentialUnits
    },
    {
        path: 'units-done-by-location',
        name: 'dashboardHeadAMDLUnitsDoneByLocation',
        component: TabUnitsDoneByLocation
    },
    {
        path: 'unsigned-units-location/:locationId',
        name: 'dashboardHeadAMDLUnsignedUnitsLocation',
        component: UnsignedUnitsLocation
    }
  ];

export default routesDashboardHeadAMDL;